var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 47,
    viewBox: "0 0 49 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8949 17.8055C48.6553 17.0722 48.0658 16.5527 47.3166 16.4191L33.1384 13.8334L26.3041 1.08085C25.939 0.404843 25.2658 0 24.4976 0C23.7332 0 23.06 0.404843 22.6987 1.08085L15.8682 13.8334L1.74705 16.4076C0.986418 16.5145 0.377911 17.0187 0.119296 17.7596C-0.139319 18.5044 0.02802 19.2873 0.56807 19.8526L10.5362 30.3212L8.60036 44.6511C8.48626 45.4074 8.79052 46.133 9.41043 46.5913C9.77173 46.8587 10.1939 47 10.6274 47C10.9317 47 11.2321 46.9313 11.5136 46.7938L24.5014 40.5072L37.493 46.7938C38.1776 47.126 38.9572 47.0535 39.581 46.599C40.2009 46.1483 40.5089 45.4265 40.4062 44.6702L38.4704 30.3212L48.4385 19.8526C48.9634 19.2988 49.1345 18.5349 48.8987 17.8055H48.8949ZM35.4203 27.5026C34.557 28.4116 34.1919 29.5497 34.3592 30.7948L35.7854 41.3513L26.228 36.7262C25.1023 36.18 23.9081 36.18 22.7824 36.7262L13.225 41.3513L14.6474 30.7948C14.8185 29.5459 14.4534 28.4078 13.5825 27.4988L6.2538 19.8029L16.6897 17.9086C17.9219 17.6832 18.8841 16.9767 19.4736 15.8729L24.5014 6.48895L29.5292 15.8729C30.1263 16.9805 31.0885 17.6832 32.3169 17.9086L42.749 19.8029L35.4203 27.4988V27.5026Z",
    fill: "#726FB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutlined);
export default __webpack_public_path__ + "static/media/star-outlined.3b98243e477a2db37685e60335b12392.svg";
export { ForwardRef as ReactComponent };